export default __webpack_public_path__ + "static/img1@2x-5f89a23f1d8f7677dfb429e0ca43f0aa.jpg";